// removed by extract-text-webpack-plugin
module.exports = {"block":"Rating__block-1OQtl","icon":"Rating__icon-1Q_Iq"};